<template>
  <!-- <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>

      <layout-sidebar></layout-sidebar> -->

      <!-- Page Wrapper -->

      <div class="page-wrapper">
        <!-- Page Content -->

        <div class="content container-fluid">
          <!-- Page Header -->

          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">
                  <span data-tour-step="1"
                    >Halo {{ memberSessionArr.name }}!</span
                  >
                </h3>

                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Beranda</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
              <ul class="nav float-right custom-menu">
                <li class="dropdown dropdown-action">
                  <a
                    href
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="material-icons">more_vert</i>
                  </a>

                  <div class="dropdown-menu dropdown-menu-right">
                    <!-- <a @click.prevent="tourShow" class="dropdown-item" href="javascript:void(0)">Tour Guide</a> -->

                    <a
                      target="_blank"
                      class="dropdown-item"
                      href="https://docs.waajo.id/automation-chatbot/membuat-balas-otomatis-welcome-chat"
                      >Dokumentasi</a
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- /Page Header -->

          <!-- <div class="row" >
    
                <div class=" col-md-12 col-sm-12 col-lg-12 col-xl-12">
    
                  <div class=" ">
    
                    <div class=" ">
    
                      <div class="alert alert-info row">
    
                        <div class="col-md-3 text-center">
    
                          <img style="height:auto;width:150px;" src="@/assets/chatbot1.png" />
    
                        </div>
    
                        <div class="col-md-9 text-wrap">
    
                          <h5>🧠🚀 Ingin tetap responsif meskipun sedang sibuk atau di luar jam kerja? Fitur Balas Otomatis di Waajo memungkinkan Anda memberikan respon instan kepada pelanggan yang menghubungi Anda, sehingga mereka merasa langsung dilayani.!</h5>
    
                          <p>
    
                          <ul style="list-style:none;">
    
                            <li><i class="fa fa-check text-success"></i> Respon Langsung: Memastikan tidak ada pesan pelanggan yang terabaikan. </li>
    
                            <li><i class="fa fa-check text-success"></i> Kontrol Spam: Mengatur seberapa sering pesan otomatis terkirim ke orang yang sama.
    
                            </li>
    
                            <li><i class="fa fa-check text-success"></i> Interaktif: Memberikan pilihan menu kepada pelanggan melalui tombol balasan.</li>
    
                          </ul>
    
                          </p>
    
                          <div class="text-left" style="margin-top:10px;">
    
                            <router-link :to="'/ai/pricing'" v-if="aiDetail.ai_engine == ''"
    
                              class="btn btn-primary btn-sm btn-outline-lime"><i class="la la-coffee"></i> Aktivasi Sekarang</router-link>
    
                            <router-link :to="'/aikey'" class="btn btn-info btn-sm btn-outline-lime" v-else><i
    
                                class="la la-coffee"></i> AI
    
                              Aktif! Cek sesi AI disini ...</router-link>
    
                          </div>
    
                        </div>
    
                      </div>
    
                    </div>
    
                  </div>
    
                </div>
    
              </div>  -->

          <div class="row">
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3"></div>
          </div>

          <Chatbot />

          <information />

          <!-- /Statistics Widget -->
        </div>

        <!-- /Page Content -->
      <!-- </div> -->
    <!-- </div> -->

    <!-- /Page Wrapper -->

    <v-tour
      name="tourGuide"
      :steps="tourSteps"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>
<script>
import Lottie from "vue-lottie";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/SidebarChatbot.vue";
import { nFormatter, getCurrentMonth } from "@/utils/helper";
import Chatbot from "./ChatBot.vue";
import Vue from "vue";
import { mapGetters } from "vuex";
import information from "./Information.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Chatbot,
    information,
  },
  data() {
    return {
      rowTotalTokenAI: {
        total_tokens: "0",
        total_tokens_used: "0",
      },
      aiDetail: {
        ai_engine: "",
        trial_status: 1,
        trial_expire: 0,
      },
      contactWaajo: process.env.VUE_APP_CONTACT_WAAJO,
      // animationsForm1: { animationData: animationReview, loop: true },
      tourId: "dashboard.admin",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete,
      },
      tourSteps: [
        {
          target: '[data-tour-step="1"]', // We're using document.querySelector() under the hood
          content: `Kamu bisa melihat statistik dan notifikasi lisensi di halaman Beranda.`,
        },
        {
          target: '[data-tour-step="2"]',
          content:
            "Informasi jumlah <b>Voucher Aktif</b> yang dapat digunakan untuk membuat akun Whatsapp baru atau memperpanjang masa aktif akun lama.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="3"]',
          content: "Jumlah akun Whatsapp yang dibuat.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="4"]',
          content: "Jumlah Kontak.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="5"]',
          content:
            "Total pesan terkirim dari semua lisensi sejak awal digunakan.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="6"]',
          content: "Statistik pesan dalam waktu 6 bulan terakhir.",
          params: {
            placement: "top",
          },
        },
      ],
    };
  },
  computed: {
    showModalOnlineDemo() {
      return this.$store.state.login.showModalOnlineDemo;
    },
    ...mapGetters(["fieldsGetLicenseList"]),
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    },
    numLicenseTotal() {
      return this.$store.state.member.numLicenseTotal;
    },
    numAgentTotal() {
      return this.$store.state.member.numAgentTotal;
    },
    numMessageTotal() {
      return this.$store.state.member.numMessageTotal;
    },
    numActiveVoucherTotal() {
      return this.$store.state.member.numActiveVoucherTotal;
    },
    numContactsTotal() {
      return this.$store.state.member.numContactsTotal;
    },
  },
  created() {
    this.getLicenseTotal();
    this.getContactsTotal();
    // this.getAgentTotal();
    this.getMessageTotal();
    this.$store.dispatch("member/getActiveVoucherTotal");
    // this.tourDetail();
    this.getAIDetail();
    this.getTotalTokenAI();
  },
  mounted() {
    // let calendlyScript = document.createElement("script");
    // calendlyScript.setAttribute(
    //   "src",
    //   "https://assets.calendly.com/assets/external/widget.js"
    // );
    // document.head.appendChild(calendlyScript);
  },
  methods: {
    async getTotalTokenAI() {
      this.$store
        .dispatch("dashboard/TotalTokenAI") // sesuai kan dengan method di API
        .then((response) => {
          var { data } = response;
          this.rowTotalTokenAI = data;
        });
    },
    getAIDetail() {
      // this.licenseArrLoading = true;
      this.$store
        .dispatch("aiKey/getDetail") // sesuai kan dengan method di API
        .then((response) => {
          let { data } = response;
          this.aiDetail = data;
          // console.log("ai detail", data)
        });
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    closeModalOnlineDemo() {
      this.$store.dispatch("login/actHideModalOnlineDemo");
    },
    redirectToLicenseByClick() {
      this.fieldsGetLicenseList.license_status = "";
      this.$router.push({ path: "/license/list" });
    },
    tourShow() {
      this.$tours["tourGuide"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId,
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId,
      };
      this.$store.dispatch("tour/tourDetail", params).then((response) => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    getMessageTotal() {
      let params = {};
      params = {
        provider: "whatsapp",
      };
      this.$store.dispatch("member/getMessageTotal", params);
    },
    getLicenseTotal() {
      this.$store.dispatch("member/getLicenseTotal");
    },
    getAgentTotal() {
      this.$store.dispatch("member/getAgentTotal");
    },
    getContactsTotal() {
      this.$store.dispatch("member/getContactsTotal");
    },
  },
  name: "overviewChatbotIndex",
};
</script>



// WEBPACK FOOTER //
// src/views/ai/chatbot/overview/index.vue